<template>
    <cart-widget-base>
        <template slot-scope="{ items, discounts, price, isOpen }">
            <div
                v-if="isOpen"
                class="card cart-widget"
            >
                <div class="card-header cart-widget-header">
                    <div class="title">
                        {{ __('Cart') }}
                    </div>
                </div>
                <div class="card-body cart-widget-items">
                    <cart-widget-item
                        v-for="item in items"
                        :key="item.id.identifier"
                        :item="item"
                    />
                    <div
                        v-if="discounts.length"
                        class="cart-discounts"
                    >
                        <p class="card-subtitle">
                            {{ __('Kedvezmények') }}
                        </p>
                        <component
                            :is="discount.type"
                            v-for="(discount, key) in discounts"
                            :key="key"
                            :discount="discount"
                        />
                    </div>
                </div>

                <div class="card cart-widget-summary">
                    <div class="card-body">
                        <div class="item">
                            <span class="label">{{ __('Total gross price:') }}</span>
                            <span class="price-value">{{ price.gross | currency }}</span>
                        </div>
                        <div class="cart-widget-footer">
                            <a
                                :href="route('shop.checkout.show')"
                                class="btn btn-primary"
                            >
                                {{ __('Checkout') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </cart-widget-base>
</template>

<script>
export default {}
</script>
